import { action, observable, runInAction } from 'mobx';
import { BaseEditViewStore, BaasicDropdownStore } from 'core/stores';
import { NikoFacilityOrderNewFlowExtraSuppliesAddForm } from 'application/niko-facility-order-inventory/forms';
import { SubCategoryService } from "application/product/services";
import { ItemSubcategoryService } from "application/facility-order/services";
import { NikoPatientTemplateService, NikoPatientTemplateItemService } from "application/niko-patient/services";
import { ClinicalStatusService } from 'application/clinical-status/services';
import _ from 'lodash';
import { subCategoriesSort } from 'core/utils';
import { ModalParams } from 'core/models';
import { LookupService } from "common/services";
import { uuid } from "core/utils";

class NikoFacilityOrderNewFlowExtraSuppliesAddModalViewStore extends BaseEditViewStore {
    @observable accessor itemCategory = "";
    @observable accessor productStore;
    @observable accessor patientTemplateItems = [];
    @observable accessor patientTemplateTrachItems = [];

    constructor(rootStore, componentProps) {
        const patientTemplateService = new NikoPatientTemplateService(rootStore.application.baasic.apiClient);
        const subCategoryService = new SubCategoryService(rootStore.application.baasic.apiClient);
        const clinicalStatusService = new ClinicalStatusService(rootStore.application.baasic.apiClient);

        super(rootStore, {
            autoInit: false,
            name: 'facility-order-extra-supplies-add-modal',
            Form: NikoFacilityOrderNewFlowExtraSuppliesAddForm,
            actions: () => {
                return {
                    // create: async (resource) => {
                    //     const { facilityOrderId, subCategoryId, clinicalStatusId } = resource;
                    //     const response = await facilityOrderTemplateService.createMasterPatientTemplateBySubCategoryNewFlow(facilityOrderId, subCategoryId, clinicalStatusId);
                    //     this.patient = response.data.patient;
                    //     return response.data;
                    // }
                    create: async (items, resource, facilityOrderId) => {
                        let patientTemplateItems = items.filter(x => x.product);
                        patientTemplateItems.forEach(i => delete i.id);

                        resource.patientTemplateMissingDocuments = resource.patientTemplateMissingDocuments && resource.patientTemplateMissingDocuments.map(i => { return { missingDocumentId: i.id } });

                        let request = {
                            ...resource,
                            facilityOrderId: facilityOrderId,
                            patientTemplateItems: patientTemplateItems,
                            isInitialIntakeReviewed: true,
                            isInsuranceReviewed: true,
                            isUsIntakeReviewed: true,
                            isClinicalReviewed: true,
                            isNew: true,
                            intakeStatusId: this.inProgressStatusId
                        }

                        const response = await patientTemplateService.createNikoMasterPatientTemplateBySubCategory(request);
                        return response.data;
                    }
                }
            },
            FormClass: NikoFacilityOrderNewFlowExtraSuppliesAddForm
        });

        this.rootStore = rootStore;
        this.modalParams = componentProps.modalParams;
        this.fetchData = this.modalParams.data.fetchData

        this.facilityOrderId = this.modalParams.data.facilityOrderId;
        this.facilityId = this.modalParams.data.facilityId;
        this.sendAgoraPo = this.modalParams.data.sendAgoraPo;
        this.skipAutoItems = this.modalParams.data.skipAutoItems;

        this.subCategoryStore = new BaasicDropdownStore({}, {
            fetchFunc: async (term) => {
                const subCategoriesAbrv = ["G-Tube", "Oral-Supplements", "Enteral", "Respiratory---trachs-supply", "Trach-Tube", "Urologicals", "Ostomy-Products"];
                const response = await subCategoryService.find({ searchQuery: term, rpp: 100, sort: "itemCategory.name|asc", embed: "ItemCategory" });

                let data = subCategoriesSort(response.data.item.map(i => { return { ...i, name: `${i.name}` } }));

                let filteredSubCategories = _.filter(data, i => {
                    return subCategoriesAbrv.some(s => i.abrv === s);
                });
                return filteredSubCategories;
            },
            onChange: async () => {
                this.setItemCatrgory();
                await this.setProductStore();

                if (this.patientTemplateItems && this.patientTemplateItems.splice) {
                    this.patientTemplateItems.splice(0); 
                }

                if (this.patientTemplateTrachItems && this.patientTemplateTrachItems.splice) {
                    this.patientTemplateTrachItems.splice(0);
                }   

                if (this.patientTemplateItems.length === 0) {
                    this.addEmptyItem(this.patientTemplateItems);
                }
            }
        });

        this.clinicalStatusStore = new BaasicDropdownStore({}, {
            fetchFunc: async () => {
                const response = await clinicalStatusService.find({ rpp: 50, isMasterPatient: true });
                return response.data.item;
            }
        });

        this.subCategoryService = subCategoryService;
        this.itemSubcategoryService = new ItemSubcategoryService(rootStore.application.baasic.apiClient);

        this.nikoPatientTemplateItemCalculationModal = new ModalParams({});
        this.fetch([
            this.initialize()
        ]);
    }

    @action
    async initialize() {
        await this.getLookups();
        await this.addEmptyItem(this.patientTemplateItems);
        this.form.clear();
    }

    @action.bound
    async getLookups() {
        const lookupService = new LookupService(this.rootStore.application.baasic.apiClient);
        const response = await lookupService.getLookups("ImportAction,ImportDetailStatus,ItemCategory,SubCategory,NewFlowStatus");
        runInAction(() => {
            this.importActions = response.importAction;
            this.importDetailStatuses = response.importDetailStatus;
            this.itemCategories = response.itemCategory;
            this.subCategories = response.subCategory;
            this.newFlowStatuses = response.newFlowStatus;
            this.inProgressStatusId = this.newFlowStatuses.find(s => s.abrv === 'in-progress').id;
        })
    }

    @action.bound
    async createResource(resource) {
        if (!this.actions.create) return;

        this.form.setFieldsDisabled(true);

        try {
            if (this.translationStore) {
                this.translationStore.applyMetadata(resource);
            }
            if (this.patientTemplateTrachItems.some(i => i.product)) {
                const respiratorySubCategory = this.subCategories.find(x => x.abrv == 'Respiratory---trachs-supply');
                var response = await this.actions.create(this.patientTemplateTrachItems, { ...resource, subCategoryId: respiratorySubCategory.id }, this.facilityOrderId);
                _.extend(resource, { linkedTemplateId: response.id })
            }

            await this.actions.create(this.patientTemplateItems, resource, this.facilityOrderId);
            
            if(this.fetchData) {
                await this.fetchData()
            }
           
            // await this.actions.create({
            //     ...resource,
            //     facilityOrderId: this.facilityOrderId
            // });
            this.form.setFieldsDisabled(false);
            // this.goToPatientTemplates();
            this.modalParams.close();

            this.rootStore.notificationStore.success('Template successfully generated.');
        }
        catch (err) {
            this.form.setFieldsDisabled(false);
            this.rootStore.notificationStore.error('Error occured while trying to create a template.');
        }
    }

    // @action.bound
    // goToPatientTemplates() {
    //     this.rootStore.routerStore.goTo(
    //         'master.app.main.facility-order.facility-order-template.edit', {
    //         patientId: this.patient.id,
    //         patientKey: this.patient.patientKey,
    //         facilityOrderId: this.facilityOrderId,
    //     },
    //     );
    // }

    @action.bound
    setItemCatrgory() {
        const oldItemCategory = this.itemCategory;
        this.itemCategory = this.subCategoryStore.value && this.subCategoryStore.value.itemCategory && this.subCategoryStore.value.itemCategory.abrv;

        if (oldItemCategory === 'enteral' && oldItemCategory !== this.itemCategory) {
            _.each(this.patientTemplateItems, item => {
                item.mlph = undefined;
                item.frequency = undefined;
                item.itemCals = 0;
                item.itemMls = 0;
            });
        }
    }

  @action.bound
  async addEmptyItem(patientTemplateItems) {
        await this.setProductStore();

        patientTemplateItems.push({
            id: uuid(),
            note: null,
            product: null,
            productId: null,
            procedureCode: null,
            mlph: undefined,
            frequency: undefined,
            itemCals: 0,
            itemMls: 0,
            quantity: 0,
            salesOrderQuantity: 0,
            importAction: this.importActions.find(x => x.abrv == 'insert'),
            importActionId: this.importActions.find(x => x.abrv == 'insert').id,
            importDetailStatusId: this.importDetailStatuses.find(x => x.abrv == 'new').id,
        });
    }

    @action.bound
    async addItem(patientTemplateItems, items, index) {
        patientTemplateItems.splice(index);
        _.each(items, i => {
            patientTemplateItems.push({
                id: uuid(),
                note: i.note,
                product: i.product,
                productId: i.product.id,
                procedureCode: i.procedureCode,
                mlph: i.mlph,
                frequency: i.frequency,
                itemCals: i.itemCals,
                itemMls: i.itemMls,
                quantity: i.quantity,
                salesOrderQuantity: i.salesOrderQuantity,
                importAction: this.importActions.find(x => x.abrv == 'insert'),
                importActionId: this.importActions.find(x => x.abrv == 'insert').id,
                importDetailStatusId: this.importDetailStatuses.find(x => x.abrv == 'new').id,
            });
        });
        this.addEmptyItem(patientTemplateItems);
    }

    @action.bound
    async deleteItem(patientTemplateItems, index) {
        patientTemplateItems.splice(index, 1);

        if (patientTemplateItems.length === 0) {
            this.addEmptyItem(patientTemplateItems);
        }
    }

    @action.bound
    editItem(patientTemplateItems, index, value, propertyName) {
        patientTemplateItems[index][propertyName] = value;
    }

    @action.bound
    async saveItem(patientTemplateItems, index, product) {
        if (product) {
            if (this.skipAutoItems) {
                patientTemplateItems.splice(index);
                patientTemplateItems.push({
                    id: uuid(),
                    note: null,
                    product: product,
                    productId: product.id,
                    procedureCode: product.procedureCode_ && product.procedureCode_.abrv,
                    mlph: undefined,
                    frequency: undefined,
                    itemCals: 0,
                    itemMls: 0,
                    quantity: 0,
                    salesOrderQuantity: 0,
                    importAction: this.importActions.find(x => x.abrv == 'insert'),
                    importActionId: this.importActions.find(x => x.abrv == 'insert').id,
                    importDetailStatusId: this.importDetailStatuses.find(x => x.abrv == 'new').id,
                });
                this.addEmptyItem(patientTemplateItems);
            } else {
                let tempItem = {
                    product: product,
                    productId: product.id,
                    procedureCode: product.procedureCode_ && product.procedureCode_.abrv
                };

                const isEnteral = this.itemCategories.some(i => i.abrv.includes("enteral") && i.id === (this.subCategoryStore.value && this.subCategoryStore.value.itemCategory && this.subCategoryStore.value.itemCategory.id));
                const itemType = (product.itemType && (product.itemType.abrv === 'bottle' || product.itemType.abrv === 'can')) || (product.procedureCode_ && product.procedureCode_.abrv === 'B4155')
                if (isEnteral && itemType) {
                    _.extend(tempItem, { itemMls: 1, itemCals: product.calsPerMl });
                }

                const patientTemplateItemService = new NikoPatientTemplateItemService(this.rootStore.application.baasic.apiClient);
                try {
                    const response = (await patientTemplateItemService.createAdditionalItems(
                        {
                            facilityId: this.facilityId,
                            patientTemplateItem: tempItem,
                            patientTemplateItems: this.patientTemplateItems.filter(i => i.product).map(i => { return { product: i.product, productId: i.productId, procedureCode: i.procedureCode } }),
                            subCategoryId: this.subCategoryStore.value && this.subCategoryStore.value.id,
                        })).data;

                    // if (tempItem.product.innerCannulaId && facilityOrderTemplateItems != this.facilityOrderTemplateTrachItems) {
                    //     const responseTrach = await facilityOrderTemplateItemService.createAdditionalTrachItemsNewFlow(
                    //         {
                    //             facilityOrderId: this.facilityOrderId,
                    //             facilityOrderItem: tempItem,
                    //             subCategoryId: this.subCategoryStore.value && this.subCategoryStore.value.id,
                    //         });
                    //     this.addItem(this.facilityOrderTemplateTrachItems, responseTrach, index);
                    // }
                    this.addItem(patientTemplateItems, response, index);

                    if (isEnteral && itemType) {
                        const item = patientTemplateItems.slice(index).find(i => i.productId == tempItem.productId);
                        if (item) {
                            index = patientTemplateItems.indexOf(item);
                            this.openNikoPatientTemplateItemCalculationModal(patientTemplateItems, index);
                        }
                    }
                }
                catch (err) {
                    return this.rootStore.notificationStore.error(err.data ? err.data : "FACILITY_ORDER_TEMPLATE_ITEM.EDIT.ERROR");
                }
            }
        }
    }

    @action.bound
    async setProductStore() {
        const ostomySubCategory = this.subCategories.find(x => x.abrv == 'Ostomy-Products');
        const isOstomySubCategory = this.subCategoryStore.value && this.subCategoryStore.value.id === ostomySubCategory.id;

        this.productStore = new BaasicDropdownStore({
            filterable: true,
            textField: "itemId",
        }, {
            fetchFunc: async (term) => {
                if (!this.subCategoryStore.value)
                    return [];

                let params = {
                    searchQuery: term,
                    rpp: 50,
                    subCategoryId: this.subCategoryStore.value.id,
                    isActive: true,
                    embed: "Product,Product.ItemType,Product.ItemCategory,Product.SubCategory,Product.UnitOfMeasure,Product.ProcedureCode_"
                }

                if (isOstomySubCategory) {
                    params = { ...params, sort: "isPreferred|desc" };
                }

                const response = await this.itemSubcategoryService.find(params);
                let filteredProducts = this.skipAutoItems ? response.data.item : response.data.item.filter(x => !x.product.itemId.toLowerCase().includes("-cs"));

                return _.map(filteredProducts, item => {
                    return {
                        ...item.product
                    };
                });
            }
        });
    }

    @action.bound
    openNikoPatientTemplateItemCalculationModal(patientTemplateItems, index) {
        this.nikoPatientTemplateItemCalculationModal.open({
            patientTemplateItem: patientTemplateItems[index],
            facilityId: this.facilityId,
            patientTemplateItemService: new NikoPatientTemplateItemService(this.rootStore.application.baasic.apiClient)
        });
    }
}

export default NikoFacilityOrderNewFlowExtraSuppliesAddModalViewStore;
